import React, { FC } from 'react';
import { Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { THEME as theme } from '../../../../styles/theme';
import logo from './../../../../assets/icons/communiq-logo-blue.png';
import background from './../../../../assets/images/communiq-bubbles-portrait-bg.png';

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Roboto-Bold',
    backgroundColor: theme.colors.neutral.secondary,
  },
  container: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    zIndex: 0,
  },
  overlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    zIndex: -1,
  },
  logo: {
    width: 160,
    height: 160,
  },
  heading: {
    fontFamily: 'Roboto-Bold',
    fontSize: 32,
    fontWeight: 800,
    color: theme.colors.primary[100],
    textAlign: 'center',
  },
  subheading: {
    fontSize: 16,
    fontWeight: 700,
    color: theme.colors.primary[100],
    textAlign: 'center',
  },
});

interface ICoverPage {
  respondent: string;
  survey: string;
}

const CoverPage: FC<ICoverPage> = ({ respondent, survey }) => {
  const { t } = useTranslation();

  return (
    <Page orientation="portrait" size="A4" style={styles.page} wrap={false}>
      <View style={styles.container}>
        <View style={styles.content}>
          <Image style={styles.logo} src={logo} />
          <Text style={styles.heading}>{survey}</Text>
          <Text style={styles.subheading}>
            {t('results.report.respondent', { data: { respondent } })}
          </Text>
        </View>
        <View style={styles.overlay}>
          <Image src={background} />
        </View>
      </View>
    </Page>
  );
};

export default CoverPage;
